import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=855bc590&scoped=true"
import script from "./leftBottom.vue?vue&type=script&lang=js"
export * from "./leftBottom.vue?vue&type=script&lang=js"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=855bc590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855bc590",
  null
  
)

export default component.exports